import { CheckoutParams } from '../../../../commonTypes/StoreTypes'
import beam from '../beam'

export const placeOrder = (cart:CheckoutParams) => beam.post('/modules/shopify/checkout', cart)
